import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organisation: "",
    service: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: "",
        email: "",
        organisation: "",
        service: "",
        message: "",
      });
    }, 5000);
  };

  const contactInfo = [
    {
      icon: "fa-envelope",
      label: "Email",
      value: "info@ingenioustech.co.za",
      href: "mailto:info@ingenioustech.co.za",
    },
    {
      icon: "fa-phone",
      label: "Phone",
      value: "(+27) 83 717 8694 ",
      href: "tel:+27XXXXXXXXX",
    },
    {
      icon: "fa-map-marker-alt",
      label: "Office",
      value: "Johannesburg / Remote",
    },
  ];

  const services = [
    "Digital Consulting & Advisory",
    "Custom Software Development",
    "Process Automation & Hyper-Automation",
    "Innovation Lab & Prototyping",
    "Training & Capability Building",
    "Other",
  ];

  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    outline: "none",
    fontSize: "16px",
    transition: "border-color 0.3s, box-shadow 0.3s",
    fontFamily: "Poppins, sans-serif",
  };
  const form = useRef();
  const [buttonText, setButtonText] = useState("Send Message"); // To show "Sending..."

  const sendEmail = (e) => {
    e.preventDefault();
    setButtonText("Sending...");

    emailjs
      .sendForm(
        "service_h5y2isj",
        "template_dxsu15y",
        form.current,
        "EfTZknChIZYKWFRDF"
      )
      .then(
        (result) => {
          console.log(result.text);
          setButtonText("Message Sent!");
          e.target.reset();
          setTimeout(() => setButtonText("Send Message"), 3000); // Reset button after 3s
        },
        (error) => {
          console.log(error.text);
          setButtonText("Failed. Try Again.");
        }
      );
  };
  return (
    <section
      id="contact"
      style={{ padding: "80px 0", backgroundColor: "white" }}
    >
      <div className="container">
        <div
          className="contact-grid"
          style={{ display: "grid", gridTemplateColumns: "1fr", gap: "64px" }}
        >
          <div>
            <span style={{ color: "#1746A2", fontWeight: 500 }}>
              Contact Us
            </span>
            <h2
              style={{
                fontSize: "clamp(1.75rem, 4vw, 2.5rem)",
                fontWeight: "bold",
                color: "#0C1A36",
                marginTop: "8px",
                marginBottom: "24px",
              }}
            >
              Get in Touch
            </h2>
            <p
              style={{
                color: "#4b5563",
                fontSize: "18px",
                marginBottom: "32px",
              }}
            >
              Ready to start your digital transformation journey? We'd love to
              hear from you.
            </p>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "24px" }}
            >
              {contactInfo.map((info, index) => (
                <div
                  key={index}
                  style={{ display: "flex", alignItems: "center", gap: "16px" }}
                >
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      backgroundColor: "rgba(23, 70, 162, 0.1)",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className={`fas ${info.icon}`}
                      style={{ color: "#1746A2" }}
                    ></i>
                  </div>
                  <div>
                    <p style={{ fontSize: "14px", color: "#6b7280" }}>
                      {info.label}
                    </p>
                    {info.href ? (
                      <a
                        href={info.href}
                        style={{
                          color: "#0C1A36",
                          fontWeight: 500,
                          textDecoration: "none",
                        }}
                      >
                        {info.value}
                      </a>
                    ) : (
                      <p
                        style={{ color: "#0C1A36", fontWeight: 500, margin: 0 }}
                      >
                        {info.value}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div
              style={{
                marginTop: "32px",
                paddingTop: "32px",
                borderTop: "1px solid #e5e7eb",
              }}
            >
              <p style={{ color: "#4b5563", marginBottom: "16px" }}>
                Follow us
              </p>
              <div style={{ display: "flex", gap: "16px" }}>
                {["linkedin-in", "twitter", "facebook-f"].map(
                  (social, index) => (
                    <a
                      key={index}
                      href="#"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#0C1A36",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        transition: "background-color 0.3s",
                      }}
                    >
                      <i className={`fab fa-${social}`}></i>
                    </a>
                  )
                )}
              </div>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#f9fafb",
              borderRadius: "16px",
              padding: "32px",
            }}
          >
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "#0C1A36",
                marginBottom: "24px",
              }}
            >
              Send us a message
            </h3>
            {!submitted ? (
              <form
                ref={form}
                onSubmit={sendEmail}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div>
                  <label
                    htmlFor="name"
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#374151",
                      marginBottom: "4px",
                    }}
                  >
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label
                    htmlFor="email"
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#374151",
                      marginBottom: "4px",
                    }}
                  >
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label
                    htmlFor="organisation"
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#374151",
                      marginBottom: "4px",
                    }}
                  >
                    Organisation
                  </label>
                  <input
                    type="text"
                    id="organisation"
                    name="organisation"
                    value={formData.organisation}
                    onChange={handleChange}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label
                    htmlFor="service"
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#374151",
                      marginBottom: "4px",
                    }}
                  >
                    Service Required *
                  </label>
                  <select
                    id="service"
                    name="service"
                    required
                    value={formData.service}
                    onChange={handleChange}
                    style={{ ...inputStyle, backgroundColor: "white" }}
                  >
                    <option value="">Select a service</option>
                    {services.map((service, index) => (
                      <option
                        key={index}
                        value={service.toLowerCase().replace(/ /g, "-")}
                      >
                        {service}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label
                    htmlFor="message"
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#374151",
                      marginBottom: "4px",
                    }}
                  >
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    required
                    value={formData.message}
                    onChange={handleChange}
                    style={{ ...inputStyle, resize: "none" }}
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="btn-primary"
                  style={{ width: "100%", justifyContent: "center" }}
                >
                  <i className="fas fa-paper-plane"></i> {buttonText}
                </button>
              </form>
            ) : (
              <div
                style={{
                  padding: "32px",
                  backgroundColor: "#f0fdf4",
                  color: "#16a34a",
                  borderRadius: "8px",
                  textAlign: "center",
                }}
              >
                <i
                  className="fas fa-check-circle"
                  style={{
                    fontSize: "48px",
                    marginBottom: "16px",
                    display: "block",
                  }}
                ></i>
                <p style={{ fontWeight: 500 }}>
                  Thank you! Your message has been sent successfully.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
                @media (min-width: 1024px) {
                    .contact-grid { grid-template-columns: 1fr 1fr !important; }
                }
            `}</style>
    </section>
  );
};

export default Contact;
